import React from 'react';
import { useTranslation } from 'react-i18next';
import { MAX_PDF_DOWNLOAD } from '../../../constants';

const DownloadExp = (): React.ReactElement => {
  const { t } = useTranslation();
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <p className="mb-1">
      <small className="form-text">
        ※ {t('millSheet.limit1')} {MAX_PDF_DOWNLOAD} {t('millSheet.limit2')}
      </small>
    </p>
  );
};

export default DownloadExp;
